export default "__VITE_ASSET__279bd38c__"